import { jsx as e } from "react/jsx-runtime";
import { tv as a } from "tailwind-variants";
const o = a({
  base: [
    "absolute",
    "gap-3",
    "inline-flex",
    "items-center",
    "right-3",
    "top-3",
    "z-10"
  ]
}), r = ({ children: s, className: t }) => /* @__PURE__ */ e("div", { className: o({ class: t }), children: s });
export {
  r as default
};
